import React, { useEffect } from 'react';

// Styles & Assets
import styles from './ZonesBedManagement.module.css';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useState, useReducer } from 'react';
import useHttp from '../../../hooks/useHttp';

// Components
import SelectableItems from '../SelectableItems/SelectableItems';
import ZonesAdmin from '../ZonesAdmin/ZonesAdmin';

// Reducers
import { selectedItemsZAdminReducer } from '../../../reducers/ZonesManagement';

// Interfaces
import { Bed, ITown } from '../../../interfaces/Patient';
import { Profile } from '../../../interfaces/Profile';
import { Zone } from '../../../interfaces/Zone';
interface Props {
    profile: Profile | null
    handleDisableAssociation: (val: boolean) => void
}


const ZonesBedManagement: React.FC<Props> = ({ profile, handleDisableAssociation }) => {

    const [selectedItems, dispatchSelectedItems] = useReducer(selectedItemsZAdminReducer, { addBedIDs: [], addTownIDs: [], removeBedIDs: [], removeTownIDs: [] });

    const [beds, setBeds] = useState<Bed[]>([]);
    const [towns, setTowns] = useState<ITown[]>([]);

    const { isLoading: loadingBeds, error: errorBeds, sendRequest: getBeds } = useHttp<Bed[]>();
    const { isLoading: loadingTowns, error: errorTowns, sendRequest: getTowns } = useHttp<ITown[]>();

    const zoneByBed = profile?.zone_by_bed;

    useEffect(() => {
        if (beds.length === 0 && zoneByBed === true)
            getBeds({
                url: getEnvironmentApiUrl() + 'bed/all',
                method: 'POST',
                body: { filter: {}, params: {} }
            }, (data) => setBeds(data));
        if (towns.length === 0 && zoneByBed === false)
            getTowns({
                url: getEnvironmentApiUrl() + 'town/all',
                method: 'POST',
                body: { filter: {}, params: {} }
            }, (data) => setTowns(data));
        dispatchSelectedItems({ type: 'RESET_ADD' });
        dispatchSelectedItems({ type: 'RESET_REMOVE' });
    }, [beds.length, getBeds, getTowns, towns.length, zoneByBed]);


    const updateBedsZoneID = (bedsZones: { id: string; zone_id: number | null }[]) => {
        setBeds(oldBeds => oldBeds.map(bed => {
            const bzFound = bedsZones.find(bz => bz.id === bed.id);
            if (!bzFound) return bed;
            return { ...bed, zone_id: bzFound.zone_id };
        }));
    };

    const handleDeletedZone = (zoneID: Zone['id']) => {
        setBeds(oldBeds => oldBeds.map(bed => bed.zone_id === zoneID ? { ...bed, zone_id: null } : bed));
        setTowns(oldTowns => oldTowns.map(town => town.zone_id === zoneID ? { ...town, zone_id: null } : town));
    };

    const items = zoneByBed === true ? beds : zoneByBed === false ? towns : [];

    return (
        <div className={styles.ZonesAndBedsContainer}>
            <ZonesAdmin
                profile={profile}
                items={items}
                selectedItems={selectedItems}
                updateBedsZoneID={updateBedsZoneID}
                handleDeletedZone={handleDeletedZone}
                handleDisableAssociation={handleDisableAssociation}
                dispatchSelectedItems={dispatchSelectedItems}
            />
            <SelectableItems
                profile={profile}
                selectedItemsIDs={zoneByBed === true ? selectedItems.addBedIDs : zoneByBed === false ? selectedItems.addTownIDs : []}
                items={items}
                loading={loadingBeds || loadingTowns}
                error={errorBeds || errorTowns}
                dispatchSelectedItems={dispatchSelectedItems}
            />
        </div>
    );
};

export default ZonesBedManagement;